export const isArrNullOrEmpty = (arrToCheck?: any[]): boolean => !arrToCheck?.length;
